// tslint:disable
export enum CoveragedetEligibilityState {
    /**
     * @description Not yet set, or no matching state found.
     */
    UNKNOWN = 0,
    /**
     * @description Eligible.
     */
    ELIGIBLE = 1,
    /**
     * @description Error.
     */
    ERROR = 2,
    /**
     * @description Invalid provider.
     */
    INVALIDPROVIDER = 3,
    /**
     * @description NO MATCH
     */
    NoMatch = 4,
    /**
     * @description NOT ELIG
     */
    NotElig = 5,
}
(CoveragedetEligibilityState as any)['NOMATCH'] = 4;
(CoveragedetEligibilityState as any)['NOTELIG'] = 5;
